import { useState } from "react";
import type { Movie } from "@/types/movie";

interface PlayerAreaProps {
  movie: Movie;
  onNotice: (message: string) => void;
}

export default function PlayerArea({ movie, onNotice }: PlayerAreaProps) {
  const [playing, setPlaying] = useState(false);

  const handlePlay = () => {
    setPlaying(true);
    onNotice("当前为演示播放器，真实在线播放功能待接入");
  };

  return (
    <div className="relative aspect-video w-full overflow-hidden rounded-lg bg-foreground-950">
      <img
        src={movie.poster}
        alt={`${movie.title} 播放预览`}
        className="absolute inset-0 h-full w-full object-cover object-top opacity-40 blur-sm"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/60 to-foreground-950/80" />

      <div className="absolute inset-0 flex flex-col items-center justify-center px-6 text-center">
        <button
          type="button"
          onClick={handlePlay}
          aria-label="播放演示"
          className={`flex items-center justify-center rounded-full bg-accent-500 text-background-50 transition-transform hover:scale-110 cursor-pointer ${
            playing ? "h-16 w-16" : "h-20 w-20"
          }`}
        >
          <i className={playing ? "ri-pause-fill text-3xl" : "ri-play-fill text-4xl"} />
        </button>
        <p className="mt-5 font-heading text-base font-semibold text-background-50 md:text-lg">
          {playing ? `${movie.title} · 演示播放中` : `点击播放《${movie.title}》`}
        </p>
        <p className="mt-2 max-w-md text-xs leading-relaxed text-background-300 md:text-sm">
          本站为演示站点，此区域仅用于展示播放器界面。真实视频播放与内容接入功能待开发。
        </p>
        {playing && (
          <div className="mt-5 w-full max-w-md">
            <div className="flex items-center gap-3">
              <span className="text-xs text-background-300">00:32</span>
              <div className="h-1 flex-1 overflow-hidden rounded-full bg-background-50/20">
                <div className="h-full w-1/3 rounded-full bg-accent-500" />
              </div>
              <span className="text-xs text-background-300">
                {movie.duration}:00
              </span>
            </div>
          </div>
        )}
      </div>

      <span className="absolute left-3 top-3 flex items-center gap-1.5 rounded-md bg-accent-500/90 px-2.5 py-1 text-xs font-semibold text-primary-950">
        <i className="ri-information-line" />
        演示播放器
      </span>
    </div>
  );
}